export default () => ({
  trigger: {
    name: 'chatbot.cancel_live_chat',
    params: {},
  },
  config: {
    event: {
      name: 'select_content',
      params: {
        sub_feature: 'live_chat',
        content: 'cancel',
      },
    },
  },
});
